// eslint-disable-next-line @typescript-eslint/naming-convention
export const LayerType = {
    VERFUEGBARKEIT: 2,
    TERMIN: 3,
    FRAKTION_INDEPENDENT: 4,
    ZUWEISUNG: 5,
    PAUSE: 10,
} as const;
